// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + {"222":"725060756e4466bdc601","402":"8845d30e250a18bb8f7b","946":"0212006e4f585aa0e231"}[chunkId] + ".min.js";
};